/**
 * ISO date entry (YYYY-MM-DD) with the kit's input look. The kit's TextInput
 * has no date type; this keeps the native picker and reports the raw string.
 */
import type { FocusEvent } from 'react'

export function DateInput({ value, onChange, id, disabled, ariaLabel, invalid, onFocus, onBlur }: {
  value: string; onChange: (value: string) => void; id?: string; disabled?: boolean; ariaLabel?: string; invalid?: boolean
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void; onBlur?: (event: FocusEvent<HTMLInputElement>) => void
}) {
  return (
    <span className={['inp', invalid ? 'is-invalid' : '', disabled ? 'is-disabled' : ''].filter(Boolean).join(' ')}>
      <input id={id} type="date" value={value} onChange={e => onChange(e.target.value)} disabled={disabled} aria-label={ariaLabel} aria-invalid={invalid || undefined} onFocus={onFocus} onBlur={onBlur} />
    </span>
  )
}
